Platform.Deferred.execute(setBlogScript);

function setBlogScript()
{
    // call matchheight for any blocks that have the class
    $('.blog-match-height').matchHeight();

    // store original sizes for images
    $('.postContent img').each(function () {
        var imgW = $(this).width();
        var imgH = $(this).height();
        $(this).data('original-width', imgW);
        $(this).data('original-height', imgH);
    });

    // images have a size set via the admin, need to handle resizing of browser to scale them down if larger than viewport
    ScaleImages()

    $(window).resize(function () {
        ScaleImages();
    });  
}

function ScaleImages() {
    $('.postContent img').each(function () {
        var containerW = $(this).closest('.postContent').width();
        var imgW = $(this).width();
        if (imgW >= containerW) {
            $(this).css('width', containerW);
            $(this).css('height', '100%');
        }
        else {
            if ($(this).data('original-width') != '') {
                $(this).css('width', $(this).data('original-width') + "px");
                $(this).css('height', $(this).data('original-height') + "px");
            }
        }
    });
}